export enum FileType {

    JPEG = "image/jpeg",
    JPG = "image/jpg",
    PNG = "image/png",
    PDF = "application/pdf",
}
